import { render } from "./password-forget.vue?vue&type=template&id=f9d2cc3e&scoped=true"
import script from "./password-forget.vue?vue&type=script&lang=js"
export * from "./password-forget.vue?vue&type=script&lang=js"

import "./password-forget.vue?vue&type=style&index=0&id=f9d2cc3e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d2cc3e"]])

export default __exports__